// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-settings-image-container {
  margin-bottom: 5px;
  height: 110px;
  line-height: 110px;
  padding: 0 25px;
  position: relative;
}
.fi-customer-settings-image-container .fi-customer-settings-image-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: var(--fi-background-color-light);
  font-size: 60px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
.fi-customer-settings-image-container .fi-customer-settings-image-icon .fa {
  align-self: center;
  flex: 1;
}
.fi-customer-settings-image-container img {
  max-height: 110px;
  max-width: 100%;
  vertical-align: top;
}

.fi-customer-settings-image-size {
  color: var(--fi-color-light);
  line-height: 1.8em;
  height: 4em;
  font-size: 0.8em;
  text-align: center;
}

fi-customer-settings-edit-image .FileUploadContainer {
  padding: 10px;
  color: var(--fi-color-dark);
  border-color: transparent;
}
fi-customer-settings-edit-image .FileUploadContainer .btn.btn-default {
  color: var(--fi-color-default);
}
fi-customer-settings-edit-image .FileUploadContainerHeaderTitle {
  font-weight: bold;
}

.fi-customer-settings-btn-image-remove {
  position: absolute;
  top: 0;
  right: 6px;
  color: var(--fi-color-default);
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/customer-settings/edit-image/edit-image.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kDAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACR;AACQ;EACI,kBAAA;EACA,OAAA;AACZ;AAGI;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;AADR;;AAKA;EACI,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAMI;EACI,aAAA;EACA,2BAAA;EACA,yBAAA;AAHR;AAKQ;EACI,8BAAA;AAHZ;AAOI;EACI,iBAAA;AALR;;AASA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,8BAAA;EACA,eAAA;AANJ","sourcesContent":[".fi-customer-settings-image-container {\r\n    margin-bottom: 5px;\r\n    height: 110px;\r\n    line-height: 110px;\r\n    padding: 0 25px;\r\n    position: relative;\r\n\r\n    .fi-customer-settings-image-icon {\r\n        width: 100px;\r\n        height: 100px;\r\n        border-radius: 50%;\r\n        background-color: var(--fi-background-color-light);\r\n        font-size: 60px;\r\n        display: flex;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n\r\n        .fa {\r\n            align-self: center;\r\n            flex: 1;\r\n        }\r\n    }\r\n\r\n    img {\r\n        max-height: 110px;\r\n        max-width: 100%;\r\n        vertical-align: top;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-image-size {\r\n    color: var(--fi-color-light);\r\n    line-height: 1.8em;\r\n    height: 4em;\r\n    font-size: 0.8em;\r\n    text-align: center;\r\n}\r\n\r\nfi-customer-settings-edit-image {\r\n    .FileUploadContainer {\r\n        padding: 10px;\r\n        color: var(--fi-color-dark);\r\n        border-color: transparent;\r\n\r\n        .btn.btn-default {\r\n            color: var(--fi-color-default);\r\n        }\r\n    }\r\n\r\n    .FileUploadContainerHeaderTitle {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-btn-image-remove {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 6px;\r\n    color: var(--fi-color-default);\r\n    font-size: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
